import { PureComponent } from "react";

import AssetStripComponent from "/components/core/asset-strip/asset-strip-component";
import ArticleItemComponent from "../article-item/article-item-component";
import SignupWithTextComponent from "/components/core/signups/signup-with-text/signup-with-text-component";
import { withAbTests } from "/contexts/ab-tests-context";

import componentStyles from "./article-template-content-component.scss";

class ArticleTemplateContentComponent extends PureComponent {
  shouldRenderFooterSignupForm() {
    const { footerSignup } = this.props;
    return footerSignup && !footerSignup.preventSignup;
  }

  render() {
    const { headerStrip, parts, footerSignup, footerDisclaimer, abTests } = this.props;

    const shouldFocusOnSignup = true;

    return (
      <div className="article-template-content-component">
        {headerStrip && (
          <AssetStripComponent
            asset={headerStrip.asset}
            title={headerStrip.title}
            subtitle={headerStrip.subtitle}
            preventSignup={headerStrip.preventSignup}
            signupFocusOnLoad={shouldFocusOnSignup}
          />
        )}

        <div className="article-items-list">
          {parts.map((part, index) => (
            <ArticleItemComponent key={index} partType={part.type} {...part.props} />
          ))}
        </div>

        <div className="content-footer-signup-wrapper">
          {this.shouldRenderFooterSignupForm() && (
            <SignupWithTextComponent title={footerSignup.title} subtitle={footerSignup.subtitle} />
          )}
        </div>
        {footerDisclaimer && (
          <div className="footer-disclaimer" dangerouslySetInnerHTML={{ __html: footerDisclaimer }} />
        )}
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

export default withAbTests(ArticleTemplateContentComponent);
